export enum PhysicalActivityLevelEnum {
  NO_ACTIVITY = 'NO_ACTIVITY',
  LIGHT_EXERCISE = 'LIGHT_EXERCISE',
  MODERATE_EXERCISE = 'MODERATE_EXERCISE',
  HEAVY_EXERCISE = 'HEAVY_EXERCISE',
  VERY_HEAVY_EXERCISE = 'VERY_HEAVY_EXERCISE',
}
